import { useLocale } from '../../context';
import { useSupportConfig } from '../../hooks/useSupportConfig';

function IconChevronRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function MobileNewRequestPicker({ onSelect }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const { config, loading } = useSupportConfig();

  if (loading) {
    return <div className="mobile-request-picker mobile-request-picker--loading">...</div>;
  }

  const groups = config?.groups || [];

  if (!groups.length) {
    return <div className="mobile-request-picker mobile-request-picker--empty">{tr('account.requests.empty')}</div>;
  }

  return (
    <div className="mobile-request-picker">
      {groups.map((group) => (
        <div key={group.id} className="mobile-request-picker__group">
          <div className="mobile-request-picker__headline">{group.label}</div>
          <div className="mobile-request-picker__list">
            {(group.templates || []).map((template) => (
              <button
                key={template.id}
                type="button"
                className="mobile-request-picker__item"
                onClick={() => onSelect?.(template.id)}
              >
                <span>{template.label}</span>
                <span className="mobile-request-picker__chevron" aria-hidden="true">
                  <IconChevronRight />
                </span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
